"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetGraphUsers = exports.getRestUsers = void 0;
var client_1 = require("@apollo/client");
var vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
var axios_1 = __importDefault(require("axios"));
var queries_1 = require("../../../../gen-src/queries");
function getUsersRequestConfig(params) {
    return {
        restApiVersion: '3.16',
        serverWideRequest: false,
        endpoint: "users/".concat(params.userLuid),
        httpMethod: 'GET'
    };
}
function queryUserOnSite(params) {
    axios_1.default.defaults.baseURL = window.location.origin;
    var makeJsonRestApiRequest = params.makeJsonRestApiRequest;
    var result = makeJsonRestApiRequest(getUsersRequestConfig(params));
    return result;
}
function getRestUsers(luids, params) {
    return __awaiter(this, void 0, void 0, function () {
        var makeJsonRestApiRequest, result, users;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    makeJsonRestApiRequest = (0, vizportalclient_common_components_1.restApiService)(params).makeJsonRestApiRequest;
                    return [4 /*yield*/, Promise.all(luids.map(function (t) { return queryUserOnSite({ userLuid: t, makeJsonRestApiRequest: makeJsonRestApiRequest }); }))];
                case 1:
                    result = _a.sent();
                    users = new Map(result.map(function (i) { var _a, _b; return [i.user.id, { username: (_a = i.user.name) !== null && _a !== void 0 ? _a : null, name: (_b = i.user.fullName) !== null && _b !== void 0 ? _b : null, domain: i.user.domain.name }]; }));
                    return [2 /*return*/, users];
            }
        });
    });
}
exports.getRestUsers = getRestUsers;
function useGetGraphUsers(luids) {
    var _a = (0, client_1.useQuery)(queries_1.GetUserDocument, {
        variables: { luids: luids },
        skip: luids.length === 0,
    }), loading = _a.loading, data = _a.data;
    return { data: data, loading: loading };
}
exports.useGetGraphUsers = useGetGraphUsers;
//# sourceMappingURL=getUsers.js.map